var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 1.25H3.41667L3.85 3.41667M5.58333 12.0833H16.4167L20.75 3.41667H3.85M5.58333 12.0833L3.85 3.41667M5.58333 12.0833L3.09937 14.5673C2.4169 15.2498 2.90025 16.4167 3.8654 16.4167H16.4167M16.4167 16.4167C15.2201 16.4167 14.25 17.3867 14.25 18.5833C14.25 19.78 15.2201 20.75 16.4167 20.75C17.6133 20.75 18.5833 19.78 18.5833 18.5833C18.5833 17.3867 17.6133 16.4167 16.4167 16.4167ZM7.75 18.5833C7.75 19.78 6.77995 20.75 5.58333 20.75C4.38672 20.75 3.41667 19.78 3.41667 18.5833C3.41667 17.3867 4.38672 16.4167 5.58333 16.4167C6.77995 16.4167 7.75 17.3867 7.75 18.5833Z",
    stroke: "#F2F2F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.c7fe1498050872f15dc11730ce706edd.svg";
export { ForwardRef as ReactComponent };